(()=>{
 let navigationController;
 const initializeNavigation=()=>{
  const header=document.querySelector('.bookids-sticky-header');
  if(!header||header.dataset.growthReady)return;
  header.dataset.growthReady='true';
  navigationController?.abort();
  navigationController=new AbortController();
  const signal=navigationController.signal;
  const links=[...header.querySelectorAll('nav a, .bookids-wholesale-link')];
  const isHome=document.body.dataset.bookidsPage==='index';
  const mark=current=>links.forEach(link=>{
   const matches=current&&current(link);
   if(matches)link.setAttribute('aria-current',isHome?'location':'page');
   else link.removeAttribute('aria-current');
  });
  if(!isHome){
   if(['product','collection','list-collections'].includes(document.body.dataset.bookidsPage))mark(link=>new URL(link.href).hash==='#setler');
   else mark(link=>new URL(link.href).pathname===location.pathname&&!new URL(link.href).hash);
   return;
  }
  const targets=['setler','kitaplar'].map(id=>document.getElementById(id)).filter(Boolean);
  let pending=false;
  const update=()=>{
   pending=false;
   const line=header.getBoundingClientRect().height+55;
   const current=targets.find(element=>{const bounds=element.getBoundingClientRect();return bounds.top<=line&&bounds.bottom>line;});
   mark(current?link=>new URL(link.href).hash==='#'+current.id:null);
  };
  const schedule=()=>{if(!pending){pending=true;requestAnimationFrame(update);}};
  window.addEventListener('scroll',schedule,{passive:true,signal});
  window.addEventListener('resize',schedule,{passive:true,signal});
  window.addEventListener('load',schedule,{once:true,signal});
  document.addEventListener('toggle',schedule,{capture:true,signal});
  update();
 };
 const initializePurchaseBars=()=>document.querySelectorAll('[data-bookids-purchase-bar]').forEach(bar=>{
  if(bar.dataset.ready)return;
  const section=bar.closest('.commerce');
  const form=section?.querySelector('.product-form');
  const submit=form?.querySelector('[data-add-button]');
  const language=form?.querySelector('#BookidsBookLanguage, [data-variant-select]');
  const price=section?.querySelector('[data-product-price]');
  const stickyButton=bar.querySelector('[data-sticky-buy]');
  if(!form||!submit||!language||!price||!stickyButton)return;
  bar.dataset.ready='true';
  document.body.classList.add('bookids-has-purchase-bar');
  const synchronize=()=>{
   const needsLanguage=!language.value;
   stickyButton.disabled=submit.disabled;
   stickyButton.textContent=submit.disabled?bar.dataset.sold:(needsLanguage?bar.dataset.choose:bar.dataset.add);
   bar.querySelector('[data-sticky-price]').textContent=price.textContent;
   const edition=language.matches('[data-variant-select]')?language.selectedOptions[0]?.dataset.bookidsEdition:({'Türkçe':'tr','Turkish':'tr','English':'en','İngilizce':'en'})[language.value];
   if(edition)section.querySelectorAll('[data-bookids-spec-editions]').forEach(spec=>{spec.querySelector('dd').textContent=edition==='tr'?spec.dataset.specTr:spec.dataset.specEn;});
  };
  form.addEventListener('change',()=>requestAnimationFrame(synchronize));
  const observer=new MutationObserver(synchronize);
  observer.observe(submit,{attributes:true,attributeFilter:['disabled']});
  observer.observe(price,{childList:true,characterData:true,subtree:true});
  stickyButton.addEventListener('click',()=>{
   if(!language.value){
    language.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    language.focus({preventScroll:true});
    return;
   }
   if(form.reportValidity())form.requestSubmit(submit);
  });
  const visibility=new IntersectionObserver(entries=>{bar.hidden=entries[0].isIntersecting;},{threshold:0.05});
  visibility.observe(form);
  synchronize();
 });
 const initialize=()=>{initializeNavigation();initializePurchaseBars();};
 initialize();
 window.addEventListener('pageshow',initialize);
 document.addEventListener('shopify:section:load',initialize);
})();
